export default {
  getRoomData (state) {
    return state.room
  },

  getRoomID (state) {
    return state.roomID
  },

  getSchichtOption (state) {
    return state.schichtOptions
  },
}
